import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, Translate } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { mediaUrl } from "../../lib/api";

export const Navbar = ({ content, onNav }) => {
  const { lang, toggle, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = [
    { k: "nav_services", id: "services" },
    { k: "nav_coverage", id: "coverage" },
    { k: "nav_about", id: "about" },
    { k: "nav_reviews", id: "reviews" },
    { k: "nav_drive", id: "drive" },
    { k: "nav_contact", id: "contact" },
  ];

  const go = (id) => { setOpen(false); onNav(id); };

  return (
    <motion.header
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-9 left-0 right-0 z-[80] transition-colors duration-300 border-b ${scrolled ? "bg-black/70 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"}`}
      data-testid="navbar"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <button onClick={() => go("hero")} className="flex items-center gap-3 group" data-testid="nav-logo">
          <img src={mediaUrl(content?.logo)} alt="MY TAXI" className="h-11 w-11 object-contain rounded-full ring-1 ring-white/10" />
          <span className="font-display text-2xl tracking-tight text-white">MY <span className="text-taxi">TAXI</span></span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}`}
              className="text-sm font-semibold uppercase tracking-wider text-white/70 hover:text-taxi transition-colors">
              {t(l.k)}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button onClick={toggle} data-testid="lang-toggle"
            className="flex items-center gap-2 border border-white/20 rounded-full px-3 py-1.5 hover:border-taxi hover:text-taxi text-white/80 transition-colors">
            <Translate size={16} weight="bold" />
            <span className="text-xs font-bold uppercase tracking-widest">{lang === "en" ? "ES" : "EN"}</span>
          </button>
          <button onClick={() => go("book")} data-testid="nav-book-btn"
            className="hidden sm:inline-flex bg-taxi text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-white transition-colors">
            {t("nav_book")}
          </button>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button key={l.id} onClick={() => go(l.id)} className="text-left font-display text-3xl text-white/90 hover:text-taxi">
                  {t(l.k)}
                </button>
              ))}
              <button onClick={() => go("book")} className="bg-taxi text-black font-bold py-3 rounded-full mt-2">{t("nav_book")}</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
